import { Fade } from "react-awesome-reveal";
import "./goals.scss";

type GoalT = {
  value: string;
  description: string;
};
const elements: GoalT[] = [
  { value: "400+", description: "Progetti Completati" },
  { value: "20+", description: "Anni di esperienza" },
  { value: "8", description: "Specialisti Qualificati" },
];

const Goals = () => {
  return (
    <section className="goals">
      {elements.map((el, i) => (
        <Fade
          key={`${i}-${el.description}`}
          direction="up"
          delay={i * 150}
          duration={800}
          triggerOnce
          damping={0.2}
        >
          <div className="goals__element" key={`${i}-${el.description}`}>
            <span className="goals__element-value">{el.value}</span>
            <h3 className="goals__element-title"> {el.description}</h3>
          </div>
        </Fade>
      ))}
    </section>
  );
};

export default Goals;
